module.exports = __webpack_public_path__ + "static/media/chevron-back-outline.fec11421.svg";